import { ChangeDetectionStrategy, Component, effect, inject, OnInit } from '@angular/core'
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser'
import { Router } from '@angular/router'
import { UrlService } from '@appShared/services/url.service'
import { AppSignals, CommonService, AccountSearchCriteria, AccountsService } from '@appShared/services'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { AccountCardComponent } from '../account-card/account-card.component'

@Component({
    selector: 'app-content-account-search',
    templateUrl: './account-search.component.html',
    styleUrls: ['./account-search.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
   imports: [FormsModule, ReactiveFormsModule, AccountCardComponent]
})
export class AccountSearchComponent implements OnInit {
   private readonly _urlService = inject(UrlService)
   private readonly _commonService = inject(CommonService)
   private readonly _router = inject(Router)
   private readonly _routes = SITE_DIRECTORY_ROUTES
   
   public user = inject(AppSignals).currentUser

   private readonly _accountService = inject(AccountsService)
   private accountSearchCriteria = this._accountService.accountSearchCriteria
   public accountSearchResults = this._accountService.accountSearchResults
   public accountSearchIsLoading = this.accountSearchResults.isLoading
   public accountSearchHasCriteria = this._accountService.accountSearchHasCriteria
   public accountSearchErrorMessage = this._accountService.accountSearchErrorMessage

   private readonly _autoNavigateOnSingleResult = effect(() => {
      const results = this.accountSearchResults.value()
      if (results?.length === 1) {
         const accountSafeId = results[0].info['safeId']/*TODO resolve to actual property when Leo gens it */
         if (accountSafeId) {
            this.goToAccountDetail(accountSafeId)
         }
      }
   })

   /* form/form-fields */
   partnerRepSourceId = new FormControl<string>(this.accountSearchCriteria().partnerRepSourceId, [
      Validators.pattern(this._commonService.regexp().dealerAccount)
   ])
   subscriptionReferenceSourceId = new FormControl<string>(this.accountSearchCriteria().subscriptionReferenceSourceId, [
      Validators.pattern(this._commonService.regexp().remittance)
   ]) 
   searchForm = new FormGroup(
      {
         partnerRepSourceId: this.partnerRepSourceId,
         subscriptionReferenceSourceId: this.subscriptionReferenceSourceId
      },
      { validators: [AccountSearchComponent._atLeastOneRequiredValidator()] }
   )

   constructor(
      titleService: Title
   ) {
      setTimeout(() => titleService.setTitle(this._routes.title))
   }

   ngOnInit() {
      setTimeout(() => { this._urlService.setHeaderTitle(this._routes.title) })
   }

   /*
   * private methods
   * */

   private static _atLeastOneRequiredValidator(): ValidatorFn {
      return (group: AbstractControl): ValidationErrors | null => {
         const dealer = (group.get('partnerRepSourceId')?.value ?? '').toString().trim()
         const remittance = (group.get('subscriptionReferenceSourceId')?.value ?? '').toString().trim()
         return dealer || remittance ? null : { atLeastOneRequired: true }
      }
   }

   /*
   * public methods
   * */

   search(): void {
      this.searchForm.markAllAsTouched()

      if (this.searchForm.invalid) {
         return
      }

      const { partnerRepSourceId, subscriptionReferenceSourceId } = this.searchForm.getRawValue()
      const searchCriteria:AccountSearchCriteria = {
         partnerRepSourceId: (partnerRepSourceId ?? '').trim(),
         subscriptionReferenceSourceId: (subscriptionReferenceSourceId ?? '').trim()
      }
      
      this._accountService.accountSearchCriteria.set(searchCriteria)
   }

   goToAccountDetail(id: string | number): void {
      const customerServiceRoutes = this._routes.customerService
      this._router.navigate([
         '/',
         customerServiceRoutes.baseUri,
         customerServiceRoutes.subscription.baseUri,
         id.toString()
      ])
   }
}
